import { LOAD_STATE } from '@shared/axios/axios.constants';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { getConversionTypesConfig } from './conversion-types.api';

export const GET_CONVERSION_TYPE_REQUEST_CALLED = '@dashboard/conversion-types/GET_CONVERSION_TYPE_REQUEST_CALLED';
export const GET_CONVERSION_TYPE_REQUEST_SUCCEEDED = '@dashboard/conversion-types/GET_CONVERSION_TYPE_REQUEST_SUCCEEDED';
export const GET_CONVERSION_TYPE_REQUEST_FAILED = '@dashboard/conversion-types/GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_FAILED';
export const GET_CONVERSION_TYPE_REQUEST_CANCELED = '@dashboard/conversion-types/GET_CONVERSION_TYPE_REQUEST_CANCELED';

export const getConversionTypesState = state => state.dashboard.conversionTypes;

export const getConversionTypesStats = ({ typeOfSelectedObj, selectedId }) => ({
    type: GET_CONVERSION_TYPE_REQUEST_CALLED,
    actionTypes: {
        success: GET_CONVERSION_TYPE_REQUEST_SUCCEEDED,
        fail: GET_CONVERSION_TYPE_REQUEST_FAILED,
        canceled: GET_CONVERSION_TYPE_REQUEST_CANCELED,
    },
    config: getConversionTypesConfig({
        typeOfSelectedObj,
        selectedId,
    }),
});

const initialState = {
    loadState: 'loading',
    data: [],
    error: null,
};

export const conversionTypesReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_CONVERSION_TYPE_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    }),
    [GET_CONVERSION_TYPE_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
        error: null,
    }),
    [GET_CONVERSION_TYPE_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: [],
        error: action.payload,
    }),
    [GET_CONVERSION_TYPE_REQUEST_CANCELED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.CANCELED,
        data: [],
        error: action.payload,
    }),
});
